
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_vrgzu_95md8_97",
  "recovery": "awsui_recovery_vrgzu_95md8_135"
};
  